module.exports = __webpack_public_path__ + "media/images/photos/27-a35b3281eea4620a397683a72608d9b1.jpg";